// extracted by mini-css-extract-plugin
module.exports = {"title":"e_jG","icon":"e_kG"};